import { PositionDto, YardBlockDto, YardBlockType } from '@yard/app/api'
import { BAY_WIDTH, ROW_HEIGHT } from '@yard/pages/YardSetup/helpers/yard-view.utils'

export const positionKey = (p: Pick<PositionDto, 'bay' | 'row' | 'tier'>): string =>
  `${p.bay}-${p.row}-${p.tier}`

const FLEX_BLOCK_BAYS = 3
const FLEX_BLOCK_ROWS = 3

export interface BlockPixelSize {
  w: number
  h: number
}

export const blockPixels = (block: YardBlockDto): BlockPixelSize =>
  block.type === YardBlockType.FlexibleBlock
    ? { w: FLEX_BLOCK_BAYS * BAY_WIDTH, h: FLEX_BLOCK_ROWS * ROW_HEIGHT }
    : { w: block.maxBays * BAY_WIDTH, h: block.maxRows * ROW_HEIGHT }

export interface RectPolyPointsTransform {
  fx: (wx: number, wy: number) => number
  fy: (wx: number, wy: number) => number
}

export const rectPolyPoints = (
  x: number,
  y: number,
  w: number,
  h: number,
  rotationDeg: number | null | undefined,
  { fx, fy }: RectPolyPointsTransform,
): string => {
  const cx = x + w / 2
  const cy = y + h / 2
  const rot = (rotationDeg ?? 0) * (Math.PI / 180)
  const cosA = Math.cos(rot)
  const sinA = Math.sin(rot)
  return [
    [-w / 2, -h / 2],
    [w / 2, -h / 2],
    [w / 2, h / 2],
    [-w / 2, h / 2],
  ]
    .map(([rx, ry]) => {
      const wx = cx + rx * cosA - ry * sinA
      const wy = cy + rx * sinA + ry * cosA
      return `${fx(wx, wy)},${fy(wx, wy)}`
    })
    .join(' ')
}
